import type { CourseDifficulty } from "../model/types";

const LABELS: Record<CourseDifficulty, string> = {
  1: "Начальный",
  2: "Базовый",
  3: "Средний",
  4: "Продвинутый",
  5: "Экспертный",
};

export function getDifficultyLabel(level: CourseDifficulty): string {
  return LABELS[level] ?? "";
}
